<template>
  <span
    :class="{
      'font-bold text-los-blue-darkest': content.bold,
      italic: content.italic,
      underline: content.underline,
    }"
    v-html="text"
  >
  </span>
</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    default: () => {},
  },
});

const text = computed(() => {
  return props.content.text.replace(/\n/g, '<br>');
});
</script>

<style lang="scss" scoped></style>
